import { UserProfileInterface } from '../userProfile/types';

/*
 * Action Types
 */
export enum DevicesTypes {
  LIST_DEVICE_REQUEST = '@devices/LIST_DEVICE_REQUEST',
  LIST_DEVICE_SUCCESS = '@devices/LIST_DEVICE_SUCCESS',
  LIST_DEVICE_FAILURE = '@devices/LIST_DEVICE_FAILURE',

  LIST_DEVICES_REQUEST = '@devices/LIST_DEVICES_REQUEST',
  LIST_DEVICES_SUCCESS = '@devices/LIST_DEVICES_SUCCESS',
  LIST_DEVICES_FAILURE = '@devices/LIST_DEVICES_FAILURE',

  UPDATE_STATUS_REQUEST = '@devices/UPDATE_STATUS_REQUEST',
  UPDATE_STATUS_SUCCESS = '@devices/UPDATE_STATUS_SUCCESS',
  UPDATE_STATUS_FAILURE = '@devices/UPDATE_STATUS_FAILURE',

  LIST_DEVICE_STATUS_REQUEST = '@device/LIST_DEVICE_STATUS_REQUEST',
  LIST_DEVICE_STATUS_SUCCESS = '@device/LIST_DEVICE_STATUS_SUCCESS',
  LIST_DEVICE_STATUS_FAILURE = '@device/LIST_DEVICE_STATUS_FAILURE',

  LIST_DEVICE_TIMELINE_REQUEST = '@device/LIST_DEVICE_TIMELINE_REQUEST',
  LIST_DEVICE_TIMELINE_SUCCESS = '@device/LIST_DEVICE_TIMELINE_SUCCESS',
  LIST_DEVICE_TIMELINE_FAILURE = '@device/LIST_DEVICE_TIMELINE_FAILURE',

  LIST_DEVICES_APP_VERSION_REQUEST = '@device/LIST_DEVICES_APP_VERSION_REQUEST',
  LIST_DEVICES_APP_VERSION_SUCCESS = '@device/LIST_DEVICES_APP_VERSION_SUCCESS',
  LIST_DEVICES_APP_VERSION_FAILURE = '@device/LIST_DEVICES_APP_VERSION_FAILURE',
}

/*
 * Data types
 */

export interface RestrictionInterface {
  id: string;
  status: number;
  reason: string | null;
  value?: string | null;
  type: number;
  previousReason: string | null;
  qualifier: string | null;
  expiresAt: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  deviceId: string;
  Caller: {
    id: string;
    name: string;
    email: string;
    photoUrl: string | null;
    createdAt: string;
    updatedAt: string;
  };
  RestrictionHistories?: RestrictionInterface[];
}

export interface DevicesInterface {
  id: string;
  type: string;
  value: string;
  label?: string | null;
  status: number | null;
  lastUsedAt: string | null;
  createdAt: string;
  updatedAt: string;
  userId: string;
  Restriction?: RestrictionInterface;
  UserProfile?: UserProfileInterface;
  platform?: string;
  screen?: string;
  os?: string;
  model?: string;
  appVersion?: string;
  DeviceTransportOperators?: any[];
  DeviceDetail?: {
    platform: string;
    screen: string;
    os: string;
    model: string;
    appVersion: string;
  };
}

export interface DeviceItem {
  deviceId: string;
  status: 'online' | 'offline' | string;
  lastHeartbeat: string;
  minutesSinceLastHeartbeat: number;
  appType: string;
  appVersion: string;
  androidVersion: string;
  batteryLevel: number;
  isCharging: boolean;
  networkType: string;
  operatorId?: string;
  employeeName?: string;
  latitude?: number;
  longitude?: number;
  freeStorage?: number;
  lastSyncStatus?: string;
  deviceModel?: string;
  deviceBrand?: string;
  deviceTimestamp?: number;
  disabledPermissions?: string;
  simCard?: string;
  carrierName?: string;
}

export interface DeviceStatusInterface {
  total: number;
  online: number;
  offline: number;
  devices: DeviceItem[];
}

export interface DeviceTimelineEntry {
  timestamp: string;
  deviceTimestamp?: number;
  appType: string;
  appVersion: string;
  androidVersion: string;
  batteryLevel: number;
  isCharging: boolean;
  networkType: string;
  operatorId?: string;
  employeeName?: string;
  latitude?: number;
  longitude?: number;
  freeStorage?: number;
  lastSyncStatus?: string;
  deviceModel?: string;
  deviceBrand?: string;
  disabledPermissions?: string;
  simCard?: string;
  status: 'online' | 'offline' | string;
}

export type DeviceVersionInterface = Record<string, number>;

export interface DeviceTimelineInterface {
  deviceId: string;
  from: string;
  to: string;
  totalHeartbeats: number;
  timeline: DeviceTimelineEntry[];
}

/*
 * State type
 */
export interface DevicesState {
  readonly devicesList: DevicesInterface[];
  readonly deviceData: DevicesInterface;
  readonly deviceStatus: DeviceStatusInterface;
  readonly deviceTimeline: DeviceTimelineInterface;
  readonly appVersions: DeviceVersionInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
